import React from "react";

const SmallTitle = (props) => {
  return <div className="text-2xl py-8 font-semibold text-red-500">{props.children}</div>;
};

export default SmallTitle;
